module.exports = __webpack_public_path__ + "media/fire.1d54f76a.mp3";